import React, { useState, useEffect } from "react"
import LocalizedLink from "./localizedLink"
import { Link } from "gatsby"
import useTranslations from "./../utils/useTranslations"
import {FaFacebook, FaTwitter, FaTelegram, FaInstagram, FaDiscord} from 'react-icons/fa';
import { IconContext } from "react-icons";
import logo from "../images/logo-white.svg"
import packageInfo from "../../package.json";
const version = packageInfo.version;

const Footer = ({pageContext: { footerText, unlocalizedPath, locale }}) => {
  const t = useTranslations(footerText)
  const [gdprComplianceRequired, setGdprComplianceRequired] = useState(false);

  useEffect(() => {
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(function (Didomi) {
      setGdprComplianceRequired(Didomi.isRegulationApplied('gdpr') || Didomi.isRegulationApplied('ccpa'));
    });
    executeDidomiCMPStub();
    window.cmpScriptLoaded = true;
  }, []);

  const executeDidomiCMPStub = () => {
    if (window.cmpScriptLoaded) {
      return;
    }

    window.gdprAppliesGlobally = false;
    const tcfScript =
      '(function(){function a(e){if(!window.frames[e]){if(document.body&&document.body.firstChild){var t=document.body;var n=document.createElement("iframe");n.style.display="none";n.name=e;n.title=e;t.insertBefore(n,t.firstChild)}else{setTimeout(function(){a(e)},5)}}}function e(n,r,o,c,s){function e(e,t,n,a){if(typeof n!=="function"){return}if(!window[r]){window[r]=[]}var i=false;if(s){i=s(e,t,n)}if(!i){window[r].push({command:e,parameter:t,callback:n,version:a})}}e.stub=true;function t(a){if(!window[n]||window[n].stub!==true){return}if(!a.data){return}var i=typeof a.data==="string";var e;try{e=i?JSON.parse(a.data):a.data}catch(t){return}if(e[o]){var r=e[o];window[n](r.command,r.parameter,function(e,t){var n={};n[c]={returnValue:e,success:t,callId:r.callId};a.source.postMessage(i?JSON.stringify(n):n,"*")},r.version)}}if(typeof window[n]!=="function"){window[n]=e;if(window.addEventListener){window.addEventListener("message",t,false)}else{window.attachEvent("onmessage",t)}}}e("__tcfapi","__tcfapiBuffer","__tcfapiCall","__tcfapiReturn");a("__tcfapiLocator");(function(e){var t=document.createElement("script");t.id="spcloader";t.type="text/javascript";t.async=true;t.src="https://sdk.privacy-center.org/"+e+"/loader.js?target="+document.location.hostname;t.charset="utf-8";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)})("23f4a63d-9222-4f37-b358-33214ecb6672")})();';
    const ccpaScript =
      '(function(){function i(e){if(!window.frames[e]){if(document.body&&document.body.firstChild){var t=document.body;var n=document.createElement("iframe");n.style.display="none";n.name=e;n.title=e;t.insertBefore(n,t.firstChild)}else{setTimeout(function(){i(e)},5)}}}function e(n,a,r,e,o){function t(e,t,n){if(typeof n!=="function"){return}if(!window[a]){window[a]=[]}var i=false;if(o){i=o(e,t,n)}if(!i){window[a].push({command:e,parameter:t,callback:n})}}t.stub=true;function i(i){if(!window[n]||window[n].stub!==true){return}if(!i.data){return}var a=typeof i.data==="string";var e;try{e=a?JSON.parse(i.data):i.data}catch(t){return}if(e[r]){var o=e[r];window[n](o.command,o.parameter,function(e,t){var n={};n.postMessageReturn={returnValue:e,success:t,callId:o.callId};i.source.postMessage(a?JSON.stringify(n):n,"*")})}}if(typeof window[n]!=="function"){window[n]=t;if(window.addEventListener){window.addEventListener("message",i,false)}else{window.attachEvent("onmessage",i)}}}e("__uspapi","__uspapiBuffer","__uspapiCall","__uspapiReturn");i("__uspapiLocator")})();';

    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.setAttribute('id', 'didomi-cmp-stub');
    scriptTag.appendChild(document.createTextNode(tcfScript));
    scriptTag.appendChild(document.createTextNode(ccpaScript));
    document.head.appendChild(scriptTag);

    window.didomiConfig = {
      regulations: {
        ccpa: {
          enabled: true,
          lspa: false, // Whether your company has signed the LSPA or not (defaults to false)
        },
      },
      notice: {
        denyOptions: {
          cross: true,
        },
      },
    };
  };

  const privacyPreferencesClick = () => {
    window.Didomi.preferences.show();
  };

  return (
     <>
        <footer>      
          <div className="container pt-5 pb-3">
            <div className="row">

              <div className="col-md-3 text-center text-md-left">
                <div className="mx-auto mb-5 mb-md-0">
                  <LocalizedLink to="/" id="footer-bt-logo">
                    <img src={logo} style={{ height: `40px` }} alt="µTorrent Footer Logo"/>
                  </LocalizedLink>
                </div>
              </div>            
              <div className="col-md-9 text-center text-md-left d-block d-sm-flex justify-content-sm-center justify-content-lg-between small">              
                <div className="col-6 offset-sm-0 col-sm-3 px-sm-0 pl-md-2 text-left d-inline-block align-top">
                  <h6 id="company" className="">{t("Company")}</h6>
                  <ul>
                      <li className="py-1 py-md-0">
                        <a href="https://www.bittorrent.com/company/about-us/" id="footer-co-about" target="_blank" rel="noopener noreferrer">
                          {t("About")}
                        </a>
                      </li>
                      <li className="py-1 py-md-0">
                        <a href="https://www.bittorrent.com/company/contact-us/" id="footer-co-contact" target="_blank" rel="noopener noreferrer">
                          {t("Contact")}
                        </a>
                      </li>
                      <li className="py-1 py-md-0">
                        <a href="https://www.bittorrent.com/blog/pressroom/" id="footer-co-press" target="_blank" rel="noopener noreferrer">
                          {t("Press")}
                        </a>
                      </li>
                      <li className="py-1 py-md-0">
                        <a href="https://www.bittorrent.com/company/jobs/" id="footer-co-jobs" target="_blank" rel="noopener noreferrer">
                          {t("Jobs")}
                        </a>
                      </li>
                      <li className="py-1 py-md-0">
                        <a href="https://blog.utorrent.com" id="footer-co-blog" target="_blank" rel="noopener noreferrer">
                          {t("Blog")}
                        </a>
                      </li>
                  </ul> 
                </div>                            
                <div className="col-5 offset-sm-0 col-sm-3 px-sm-0 pl-md-2 text-left d-inline-block align-top align-top" >
                  <h6 id="downloads" className="">{t("Downloads")}</h6>
                  <ul>
                      <li className="py-1 py-md-0">
                        <LocalizedLink to="/downloads/win/" id="footer-dl-windows">
                          {t("Windows")}
                        </LocalizedLink>
                      </li>
                      <li className="py-1 py-md-0">
                        <LocalizedLink to="/downloads/mac/" id="footer-dl-mac">
                          {t("Mac")}
                        </LocalizedLink>
                      </li>
                      <li className="py-1 py-md-0">
                        <LocalizedLink to="/downloads/android/" id="footer-dl-android">
                          {t("Android")}
                        </LocalizedLink>
                      </li>
                      <li className="py-1 py-md-0">
                        <LocalizedLink to="/downloads/linux/" id="footer-dl-linux">
                          {t("Linux")}
                        </LocalizedLink>
                      </li>
                  </ul>
                </div>                            
                <div className="col-6 offset-sm-0 col-sm-3 px-sm-0 pl-md-2 text-left d-inline-block align-top">
                  <h6 id="help" className="">{t("Support")}</h6>
                  <ul>
                      <li className="py-1 py-md-0">
                        <a href="https://bittorrent.com/help/" target="_blank" id="footer-sup-help" rel="noopener noreferrer">
                          {t("Help")}
                        </a>
                      </li>
                      <li className="py-1 py-md-0">
                        <a href="https://forum.utorrent.com/" target="_blank" id="footer-sup-forum" rel="noopener noreferrer">
                          {t("Forum")}
                        </a>
                      </li>
                      <li className="py-1 py-md-0">
                        <a href="https://www.surveymonkey.com/r/5CJKRDC" target="_blank" id="footer-sup-feedback" rel="noopener noreferrer">
                          {t("Site Feedback")}
                        </a>
                      </li>
                  </ul> 
                </div>                
                <div className="col-5 offset-sm-0 col-sm-3 px-sm-0 pl-md-2 text-left d-inline-block align-top">
                    <h6 id="social" className="">{t("Social")}</h6>
                    <ul>
                      <IconContext.Provider value={{ className: "" }}>
                        <li className="py-1 py-md-0"><a id="footer-social-fb" href="https://facebook.com/utorrent" className="facebook" target="_blank" rel="noopener noreferrer"><FaFacebook /> Facebook</a></li>
                        <li className="py-1 py-md-0"><a id="footer-social-twitter" href="https://twitter.com/utorrent" className="twitter" target="_blank" rel="noopener noreferrer"><FaTwitter /> Twitter</a></li>
                        <li className="py-1 py-md-0"><a id="footer-social-instagram" href="https://instagram.com/utorrent" className="instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /> Instagram</a></li>
                        <li className="py-1 py-md-0"><a id="footer-social-discord" href="https://discord.com/invite/pn6WWmXtQV" className="discord" target="_blank" rel="noopener noreferrer"><FaDiscord /> Discord</a></li>
                      </IconContext.Provider>
                  </ul>
                </div>
              </div>            

            </div>

            { (locale === "en" && unlocalizedPath === "/") &&
            <>
            <hr style={{ margin: `2.5rem 0` , borderTop:`1px solid gray` }} />

            <div className="row">
              <div className="col-12 col-sm-10 text-center text-lg-left col-lg-3 mb-3 mb-lg-0 mx-auto">
                <h6>{t(`Languages`)}</h6>
                <small className="mb-0" style={{lineHeight:2}}>{t(`µTorrent is global! Our website is fully translated in 17 languages.`)}</small>
              </div>
              <div className="mx-auto text-center text-sm-left col-12 col-sm-9 col-md-8 col-lg-9 flex-wrap mt-4 d-block d-sm-flex small">
                <div className="d-inline-block col-6 col-lg-3 px-sm-0 pl-sm-4 pl-md-5 pl-lg-2 text-left text-nowrap">
                  <Link className="d-block" to={'/intl/zh_cn'+ unlocalizedPath} hrefLang="zh_CN" id="footer-flags-zh_cn" className="d-block my-3">下载 µTorrent</Link>
                  <Link className="d-block" to={'/intl/zh_tw'+ unlocalizedPath} hrefLang="zh_TW" id="footer-flags-zh_tw" className="d-block my-3">下載 µTorrent</Link>
                  <Link className="d-block" to={'/intl/de'+ unlocalizedPath} hrefLang="de" id="footer-flags-de" className="d-block my-3">µTorrent herunterladen</Link>
                  <Link className="d-block" to={'/intl/es'+ unlocalizedPath} hrefLang="es" id="footer-flags-es" className="d-block my-3">Descargar µTorrent</Link>
                </div>
                <div className="d-inline-block col-5 col-sm-6 col-lg-3 px-sm-0 pl-sm-4 pl-md-5 pl-lg-2 text-left text-nowrap">
                  <Link className="d-block" to={'/intl/fr'+ unlocalizedPath} hrefLang="fr" id="footer-flags-fr" className="d-block my-3">Téléchargez µTorrent</Link>
                  <Link className="d-block" to={'/intl/hi'+ unlocalizedPath} hrefLang="hi" id="footer-flags-hi" className="d-block my-3">µTorrent डाउनलोड करें</Link>
                  <Link className="d-block" to={'/intl/it'+ unlocalizedPath} hrefLang="it" id="footer-flags-it" className="d-block my-3">Scarica µTorrent</Link>
                  <Link className="d-block" to={'/intl/ko'+ unlocalizedPath} hrefLang="ko" id="footer-flags-ko" className="d-block my-3">µTorrent 다운로드</Link>
                </div>
                <div className="d-inline-block col-6 col-lg-3 px-sm-0 pl-sm-4 pl-md-5 pl-lg-2 text-left text-nowrap">
                  <Link className="d-block" to={'/intl/ja'+ unlocalizedPath} hrefLang="ja" id="footer-flags-ja" className="d-block my-3">µTorrentをダウンロード</Link>
                  <Link className="d-block" to={'/intl/nl'+ unlocalizedPath} hrefLang="nl" id="footer-flags-nl" className="d-block my-3">Download µTorrent</Link>
                  <Link className="d-block" to={'/intl/pl'+ unlocalizedPath} hrefLang="pl" id="footer-flags-pl" className="d-block my-3">Pobierz µTorrent</Link>
                  <Link className="d-block" to={'/intl/pt_br'+ unlocalizedPath} hrefLang="pt_BR" id="footer-flags-pt_br" className="d-block my-3">Baixar µTorrent</Link>
                </div>
                <div className="d-inline-block col-5 col-sm-6 col-lg-3 px-sm-0 pl-sm-4 pl-md-5 pl-lg-2 text-left text-nowrap">
                  <Link className="d-block" to={'/intl/pt'+ unlocalizedPath} hrefLang="pt" id="footer-flags-pt" className="d-block my-3">Transferir µTorrent</Link>
                  <Link className="d-block" to={'/intl/ru'+ unlocalizedPath} hrefLang="ru" id="footer-flags-ru" className="d-block my-3">Скачать µTorrent</Link>
                  <Link className="d-block" to={'/intl/tl'+ unlocalizedPath} hrefLang="tl" id="footer-flags-tl" className="d-block my-3">I-download ang µTorrent</Link>
                  <Link className="d-block" to={'/intl/tr'+ unlocalizedPath} hrefLang="tr" id="footer-flags-tr" className="d-block my-3">µTorrent'i indir</Link>
                </div>
              </div>
            </div>
            </>
            }

            <hr style={{ margin: `2.5rem 0` , borderTop:`1px solid gray` }} />

            <div className="row mb-2 mb-sm-4">
              <div className="col-12 col-md-5 order-2 order-md-1 mt-2 mt-md-2 mb-4 mb-md-0 text-center text-md-left small">Version {version} &copy; {new Date().getFullYear()} {t(`µTorrent is a trademark of BitTorrent Limited.`)}</div>
              <div className="col-12 col-md-7 order-1 order-md-2 mt-0 mt-md-2 mb-1 mb-md-0 text-center text-md-right small">
                <a href="https://www.bittorrent.com/legal/eula/" id="footer-co-eula" target="_blank" rel="noopener noreferrer">
                  {t("EULA")}
                </a>
                <span className="footer-vertical-line"> | </span>
                <a href="https://www.bittorrent.com/legal/copyright/" id="footer-co-copyright" target="_blank" rel="noopener noreferrer">
                  {t("Copyright")}
                </a>
                <span className="footer-vertical-line"> | </span>
                <a href="https://www.bittorrent.com/legal/terms-of-use/" id="footer-co-tos" target="_blank" rel="noopener noreferrer">
                  {t("termsOfUse")}
                </a>
                <span className="footer-vertical-line"> | </span>
                <a href="https://www.bittorrent.com/legal/privacy-policy/" id="footer-co-privacy" target="_blank" rel="noopener noreferrer">
                  {t("Privacy")}
                </a>
                {(gdprComplianceRequired && window.cmpScriptLoaded) && (
                  <>
                    <span className="footer-vertical-line"> | </span>
                    <div onClick={privacyPreferencesClick} id="footer-co-privacy-pref" className="d-inline pointer">
                      {t("Privacy Preferences")}
                    </div>
                  </>
                )}
              </div>
            </div>     
          </div>      
        </footer>
      </>
  )
}

export default Footer

